module.exports = __webpack_public_path__ + "img/dumas_pere.9a76c1bc.jpg";